import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import DepartmentActions from '@Actions/departmentActions';
import './style.scss';
import Helpers from '@Apis/helpers';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function SelectDepartment({
  departments, onChange, selectedDepartment, disabled, showError, title, hideTitle, containerClassName, inputClassName, labelClassName, loading,
  getDepartments, user, customStyle, tenantId, emptyNotAllowed, getDepartmentsLoading, excludedDepartments, tenentLevelDepartment, noDropdownAlign, showSearch, isMultiple, allowClear,
  placeholderText, bordered, getPopupContainer, multipleSelectedTenantIds,tenantsDepartmentsData
}) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentTenant, setCurrentTenant] = useState(false);
  const [dropDownVisible, setDropDownVisible] = useState(false);

  // this useEffect will only created for downloading reports for multi tenant at that time all dep is required
  if(!tenantsDepartmentsData){
    useEffect(() => {
      if (multipleSelectedTenantIds) {
        getDepartments('', '', 1, 100, null, null, null, null, multipleSelectedTenantIds);
      }
    }, [multipleSelectedTenantIds]);

    useEffect(() => {
      if ((!departments && !getDepartmentsLoading) || (departments && !getDepartmentsLoading && currentTenant !== tenantId && tenantId) || (departments && !getDepartmentsLoading && dropDownVisible)) {
        setCurrentTenant(tenantId);
        getDepartments('', tenantId || user?.tenant_info?.tenant_id, 1, 100);
        setDropDownVisible(false);
      }
      setIsAdmin(!!window.location.href.includes('/admin'));
    }, [tenantId, multipleSelectedTenantIds, dropDownVisible]);
  }

  let departmentsData = tenantsDepartmentsData || departments?.data?.result?.departments || [];

  return (
    <div className={`${containerClassName || 'orgInputContainer'} select-department__wrapper`}>
      {!hideTitle ? (
        <label className={labelClassName || 'orgFormLabel'}>
          {title || 'Department'}
          <span style={{ color: 'red' }}>{'  *'}</span>
        </label>
      ) : <React.Fragment />}
      <PRZSelect
        mode={isMultiple ? 'multiple' : ''}
        value={departmentsData ? selectedDepartment : ''}
        filterOption={false}
        disabled={disabled}
        getPopupContainer={getPopupContainer}
        onChange={(value) => {
          if (tenentLevelDepartment) {
            if (isMultiple) onChange(value);
            else onChange(departmentsData?.filter((department) => department?.tenant_department_id === value)[0]);
          } else if (isMultiple) {
            onChange(value);
          } else {
            onChange(departmentsData?.filter((department) => department?.department_id === value)[0]);
          }
        }}
        onDropdownVisibleChange={(value) => setDropDownVisible(value)}
        style={customStyle || {
          height: '28px',
          width: '100%',
          borderRadius: '4px',
        }}
        className={inputClassName || 'input'}
        bordered={bordered || true}
        showSearch={showSearch}
        onSelect={() => {
          // getDepartments('', tenantId || user?.tenant_info?.tenant_id, 1, 1000);
        }}
        onSearch={(value) => {
          getDepartments(value, tenantId || user?.tenant_info?.tenant_id, 1, 1000);
        }}
        placeholder={placeholderText || 'Search by department..'}
        loading={getDepartmentsLoading || loading}
        maxTagCount={isMultiple ? 'responsive' : ''}
        status={showError ? 'error' : ''}
        allowClear={allowClear}
      >
        {(!emptyNotAllowed && !isMultiple) && (
          <Option key="NULL" value="">
            All Departments
          </Option>
        )}
        {departmentsData?.length && departmentsData
          ?.filter((item) => !excludedDepartments?.includes(item?.department_id))
          ?.map((item) => (
            <Option key={tenentLevelDepartment ? item.tenant_department_id : item.department_id} value={tenentLevelDepartment ? item.tenant_department_id : item.department_id}>
              {`${item?.department_info?.department_name} `}
            </Option>
          ))}
      </PRZSelect>
      {showError && (
        <div className="input-error">
          *Please select department
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({ DepartmentReducers, UserReducers }) => ({
  getDepartmentsLoading: DepartmentReducers.getDepartmentsLoading,
  departments: DepartmentReducers.departments,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback, orgId, isAdmin, multipleSelectedTenantIds) => dispatch(
    DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback, orgId, isAdmin, multipleSelectedTenantIds),
  ),
});

SelectDepartment.propTypes = {
  user: PropTypes.any,
  departments: PropTypes.any,
  placeholderText: PropTypes.any,
  selectedDepartment: PropTypes.any,
  getDepartments: PropTypes.func,
  getDepartmentsLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  customStyle: PropTypes.any,
  tenantId: PropTypes.any,
  emptyNotAllowed: PropTypes.bool,
  tenentLevelDepartment: PropTypes.bool,
  showSearch: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectDepartment));
